import * as React from 'react';
import canUseDom from "rc-util/es/Dom/canUseDom";
export var useLayoutEffect = canUseDom() ? React.useLayoutEffect : React.useEffect;


//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-components-antd-x4/node_modules/rc-input-number/es/hooks/useLayoutEffect.js
// module id = 2777
// module chunks = 0